module.exports = __webpack_public_path__ + "img/hypos_logo.c75b40c3.png";